import {isReactNativeWebView} from '../../native'
import {getFriendAndFamilyCugType} from './getFriendAndFamilyCugType'
import {getPlusCugType, TokenFromUrlParams} from './getPlusCugType'
import {
  MOBILE_APP_CUG_TYPE,
  OFFLINE_CUG_TYPE,
  SENSITIVE_CUG_TYPE,
  SIGNED_IN_CUG_TYPE
} from './privateDeals'

interface CugDealsParameters {
  isMemberPlus: boolean
  isEmployee: boolean
  urlParams: TokenFromUrlParams
  isBrandOffersLockedByDefault?: boolean
}

/**
 * @deprecated
 * Use hook useCugOffersParameters
 */
export const getCugDealsParameter = ({
  isMemberPlus,
  isEmployee,
  urlParams,
  isBrandOffersLockedByDefault = true
}: CugDealsParameters) => {
  return [
    SIGNED_IN_CUG_TYPE,
    OFFLINE_CUG_TYPE,
    SENSITIVE_CUG_TYPE,
    ...(isReactNativeWebView() ? [MOBILE_APP_CUG_TYPE] : []),
    ...getPlusCugType(isMemberPlus, urlParams, isBrandOffersLockedByDefault),
    ...getFriendAndFamilyCugType(isEmployee)
  ]
}
